import React, { useEffect, useState } from "react";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { AuthProvider } from "./Hooks/AuthContext";
import { NextUIProvider } from "@nextui-org/react";
import { Row, Col } from "antd";
import MainLayout from "./Routes/MainLayout";
import { isEmpty } from "lodash";
import { unAuthGet } from "./Services/api.service";
import { Paths } from "./Services/EndPoints";
import { setStoreDetails } from "./Redux/Actions";
import StoreNotFound from "./Pages/Store/StoreNotFound";
import { HistoryProvider } from "./Routes/HistoryContext";
import { useQuery } from "./Hooks/useQuery";
import HelmetMetaData from "./HelmetMetaData";
function App() {
  const [isVisible, setIsVisible] = useState(false);
  const user = JSON.parse(localStorage.getItem("userData"));
  const query = useQuery();
  const dispatch = useDispatch();
  const storeDetails = useSelector((state) => state.storeDetails);
  const [storeData, setStoreData] = useState(null);

  const generateSessionToken = () => {
    const timestamp = Date.now();
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let token = "";
    for (let i = 0; i < 10; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      token += characters[randomIndex];
    }
    return `${timestamp}${token}`;
  };

  useEffect(() => {
    if (isEmpty(storeDetails)) {
      unAuthGet(Paths.store_details)
        .then((res) => {
          if (!isEmpty(res?.data)) {
            setStoreData(res?.data);
            dispatch(setStoreDetails(res?.data));
          } else {
            setIsVisible(true);
          }
        })
        .catch((err) => console.log(err));
    }
    if (user === null || isEmpty(user)) {
      if (
        isEmpty(sessionStorage.getItem("sessionToken")) ||
        sessionStorage.getItem("sessionToken") === null
      ) {
        const sessionToken = generateSessionToken();
        sessionStorage.setItem("sessionToken", sessionToken);
      }
    } else {
      sessionStorage.setItem("sessionToken", null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeDetails, user]);

  return (
    <>
      <HelmetMetaData
        title={storeData?.storeName}
        description={storeData?.storeDesc}
        favIcon={storeData?.storeUrl}
        storeLink={storeData?.storeLink}
      />
      <AuthProvider>
        <NextUIProvider>
          <HistoryProvider>
            <Row justify="center">
              <Col
                xxl={14}
                lg={20}
                md={22}
                sm={20}
                xs={24}
                xl={18}
                className="bg-[#F9FAFB]"
              >
                {isVisible &&
                isEmpty(storeDetails) &&
                query.get("ref") !== "WA" ? (
                  <StoreNotFound />
                ) : (
                  <MainLayout />
                )}
              </Col>
            </Row>
          </HistoryProvider>
        </NextUIProvider>
      </AuthProvider>
    </>
  );
}

export default App;
